import React, { useState } from "react";
import { Form } from "react-bootstrap";
import StyledInput from "../../components/StyledComponents/StyledInput";
import StyledText from "../../components/StyledComponents/StyledText";
import StyledButton from "../../components/StyledComponents/StyledButton";
import AuthSlider from "../../components/AuthSlider";
import { Link, useNavigate } from "react-router-dom";
import { useSignupMutation } from "../../services/apis";
import {
  emailValidationRules,
  passwordUpdationValidationRules,
  stringValidationRules,
  validateForm,
} from "../../utils/helper";
import { toast } from "react-toastify";
import { theme } from "../../theme";

const Signup = () => {
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const [getUser, { isLoading: isLoadingUser }] = useGetUserMutation();
  // const [getEmployeeListing, { isLoading: isLoadingEmployee }] = useGetEmployeeListingMutation();
  // const [signupSSO, { isLoading: getSSOUrlLoading }] = useGetSSOSignupUrlMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const [signup, { isLoading }] = useSignupMutation();
  const handleInputChange = (fieldName, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  const [errors, setErrors] = useState({});
  const validationRules = {
    email: emailValidationRules,
    password: passwordUpdationValidationRules,
    firstName: stringValidationRules,
    lastName: stringValidationRules,
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationErrors = validateForm(formData, validationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    try {
      const { data, error } = await signup({
        ...formData,
        password: formData.password.trim(),
      });
      if (error) {
        toast.error(
          error?.errorMessage ||
            error?.data?.errorMessage ||
            error?.data?.errors?.[0]?.errorMessage ||
            "Signup failed. Please try again.",
        );
        return;
      }

      if (data) {
        navigate("/email-invitation", { state: { email: formData?.email } });
      }
    } catch (error) {
      console.error("An unexpected error occurred. Please try again.");
    }
  };

  // const callHandleSSO = (provider) => handleSSO(provider, signupSSO, getUser, getEmployeeListing, dispatch, navigate);

  return (
    <AuthSlider>
      <h2 className="welcome-heading mb-2 text-center text-md-start">
        Create Your Account Here
      </h2>
      <h5 className="signin-text text-center text-md-start">
        Please enter details to create your account.
      </h5>

      <Form noValidate onSubmit={handleSubmit} className="py-2 py-md-4 pb-md-0">
        <div className="d-flex gap-3">
          <StyledInput
            label="First Name"
            placeholder="Please enter your first name here"
            value={formData.firstName}
            onChange={(e) => handleInputChange("firstName", e.target.value)}
            required
            error={errors.firstName}
          />
          <StyledInput
            label="Last Name"
            placeholder="Please enter your last name here"
            value={formData.lastName}
            onChange={(e) => handleInputChange("lastName", e.target.value)}
            required
            error={errors.lastName}
          />
        </div>
        <StyledInput
          label="Email Address"
          placeholder="Please enter your email address here"
          value={formData.email}
          onChange={(e) => handleInputChange("email", e.target.value)}
          required
          error={errors.email}
        />

        <div className="position-relative">
          <StyledInput
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            placeholder="Please set your password here"
            label="Password"
            autoComplete="on"
            style={{ paddingRight: "35px" }}
            value={formData.password}
            onChange={(e) => handleInputChange("password", e.target.value)}
            error={errors.password}
            color={theme.logoColor}
            required
          />
        </div>

        <StyledButton
          _variant="primaryGradiant"
          type="submit"
          className="w-100 sign-in-btn p-md-3 mt-3 mt-md-4"
          $fontWeightMd="600"
          // loading={isLoading || isLoadingUser || isLoadingEmployee}
          loading={isLoading}
        >
          Create My Account
        </StyledButton>
        <StyledText as="div" className="text-center mt-2" $fontSize="0.9rem">
          Already have an account?
          <StyledText
            as={Link}
            color="secondary"
            to="/login"
            className="fw-semibold ms-1"
          >
            Login Here
          </StyledText>
        </StyledText>
      </Form>
      {/* <hr className="mt-4 mb-4" />
      <StyledButton
        onClick={() => callHandleSSO("MICROSOFT")}
        _variant='icon'
        disabled={getSSOUrlLoading}
        className='p-0 my-3 w-100'
      >
        <div className={`d-flex btn btn-outline-primary align-items-center gap-2 justify-content-center`}>
          <OutlookIcon />
          <div style={{ fontSize: '14px', fontWeight: '500' }}>
            Signup with Microsoft
          </div>
        </div>
      </StyledButton>
      <StyledButton
        onClick={() => callHandleSSO("GOOGLE")}
        _variant='icon'
        disabled={getSSOUrlLoading}
        className='p-0 w-100'
      >
        <div className={`d-flex btn btn-outline-primary align-items-center gap-2 justify-content-center`}>
          <GoogleIcon />
          <div style={{ fontSize: '14px', fontWeight: '500' }}>
            Signup with Google
          </div>
        </div>
      </StyledButton> */}
    </AuthSlider>
  );
};

export default Signup;
